import React from 'react';
import { HeroTypes } from '..';

export const HeroSection4 = ({ children }: HeroTypes.ILocationHero) => {
  return (
    <div className="HeroSection3container">
      {children || `this is a placeholder for HeroSection3 component`}
    </div>
  );
};
